import {Component, EventEmitter, Input, Output} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-sheet',
  imports: [],
  templateUrl: './sheet.html',
  styleUrl: './sheet.scss',
  animations: [
    trigger('sheetAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate(
          '400ms cubic-bezier(0.33, 1, 0.68, 1)',
          style({ transform: 'translateY(0)', opacity: 1 })
        )
      ]),
      transition(':leave', [
        animate(
          '300ms cubic-bezier(0.33, 1, 0.68, 1)',
          style({ transform: 'translateY(100%)', opacity: 0 })
        )
      ])
    ]),
    trigger('backgroundAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms cubic-bezier(0.33, 1, 0.68, 1)', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms cubic-bezier(0.33, 1, 0.68, 1)', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class Sheet {
  @Input() open = false;
  @Output() closed = new EventEmitter<void>();

  public openSheet() {
    this.open = true;
  }

  public closeSheet() {
    this.open = false;
    this.closed.emit();
  }
}
